module.exports = __webpack_public_path__ + "static/media/1_en.74d6b8ba.png";